module.exports = __webpack_public_path__ + "img/exportTXT.b04e248c.svg";